/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const Invoice = {
  path: '/invoice',
  name: 'invoice',
  component: () => import(/* webpackChunkName: "expect" */ '@/views/invoice/index.vue'),
  children: [
    {
      path: 'confirm',
      name: 'invoice-confirm',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/invoice/confirm.vue'),
    },
    {
      path: 'confirm-new',
      name: 'invoice-confirm-new',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/invoice/confirm-new.vue'),
    },
    {
      path: 'select',
      name: 'invoice-select',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/invoice/select.vue'),
    },
    {
      path: 'edit',
      name: 'invoice-edit',
      component: () => import(/* webpackChunkName: "device-replace" */ '@/views/invoice/edit.vue'),
    },
    {
      path: 'address-list',
      name: 'invoice-address-list',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/invoice/address-list.vue'),
    },
    {
      path: 'address-edit',
      name: 'invoice-address-edit',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/invoice/address-edit.vue'),
    },
    {
      path: 'confirm-qd',
      name: 'invoice-confirm-qd',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/invoice/confirm-qd.vue'),
    },
    {
      path: 'select-qd',
      name: 'invoice-select-qd',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/invoice/select-qd.vue'),
    },
    {
      path: 'edit-qd',
      name: 'invoice-edit-qd',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/invoice/edit-qd.vue'),
    },
    {
      path: 'type-select',
      name: 'invoice-type-select',
      component: () =>
        import(/* webpackChunkName: "malfunction-repair" */ '@/views/invoice/type-select.vue'),
    },
    {
      path: 'user-invoice-list',
      name: 'invoice-user-invoice-list',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/invoice/user-invoice-list.vue'
        ),
    },
  ],
}
export default Invoice
